import React from 'react';
import { Table, Tag } from 'antd';
import moment from 'moment';
import { formatNumberWithCommas } from '../../../utils/numbers';

const ReconciliationTable = ({ rows, loading }) => {
    const formatPayPeriod = (payPeriod) => {
        if (!payPeriod) return 'N/A';
        const [start, end] = payPeriod.split(' to ');
        const startDate = moment(start, 'DD-MM-YYYY HH:mm:ss');
        const endDate = moment(end, 'DD-MM-YYYY HH:mm:ss');
        return `${startDate.format('MMM Do, YYYY')} - ${endDate.format('MMM Do, YYYY')}`;
    };

    const getDaysPastDueColor = (days) => {
        if (days === 0) return 'green';
        if (days <= 30) return 'orange';
        if (days <= 90) return 'red';
        return 'volcano';
    };

    const columns = [
        {
            title: 'Account Name',
            dataIndex: 'account_name',
            key: 'account_name',
            width: 150,
            render: (text) => <p>{text || 'N/A'}</p>,
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            width: 200,
            render: (text) => <p>{text || 'N/A'}</p>,
        },
        {
            title: 'Amount Due',
            dataIndex: 'amount_due',
            key: 'amount_due',
            width: 120,
            render: (text) => <p>${formatNumberWithCommas(text, true)}</p>,
        },
        {
            title: 'Days Past Due',
            dataIndex: 'days_past_due',
            key: 'days_past_due',
            width: 130,
            render: (days) => <Tag color={getDaysPastDueColor(days)}>{days === 0 ? 'Current' : `${days} days`}</Tag>,
        },
        {
            title: 'Pay Period',
            dataIndex: 'pay_period',
            key: 'pay_period',
            width: 200,
            render: (text) => <p>{formatPayPeriod(text)}</p>,
        },
        {
            title: 'Scheduled For',
            dataIndex: 'scheduled_for',
            key: 'scheduled_for',
            width: 130,
            render: (text) => <p>{moment(text).format('MM/DD/YYYY')}</p>,
        },
        {
            title: 'Client ID',
            dataIndex: 'client_id',
            key: 'client_id',
            width: 150,
            render: (text) => <p>#{text?.slice(-8)}</p>,
        },
    ];

    return <Table dataSource={rows} columns={columns} loading={loading} rowKey="client_id" pagination={{ pageSize: 15 }} scroll={{ x: 1000 }} />;
};

export default ReconciliationTable;
